import React, { useEffect, useState } from "react";
import moment from "moment";
import { useFormattedMessage } from "hooks";

const messages = {
    orderExpired: "dashboard_orderExpired",
    orderExpireTime: "dashboard_orderExpireTime",
};

const TimeOutCountDown = ({
    className = "",
    timeout,
    expiryDate,
    noText = false,
    textClassName,
    orderExpired,
    timeAboutToEnd,
    showUnit = false,
}) => {
    const { formatMessage } = useFormattedMessage();
    const formattedTime = timeout && moment(timeout, "HH-mm-ss").format("HH:mm:ss");
    const date = expiryDate && moment(expiryDate).format("YYYY-MM-DD");
    const utcDataTime = formattedTime && date ? date + " " + formattedTime : "";
    const offset = moment().utcOffset();
    const localTimeDate = utcDataTime && moment.utc(utcDataTime).utcOffset(offset).format("YYYY-MM-DD_HH:mm:ss");
    const splitLocalTimeDate = localTimeDate && localTimeDate.split("_");
    const localDate = splitLocalTimeDate && splitLocalTimeDate[0];
    const localTime = splitLocalTimeDate && splitLocalTimeDate[1];
    const formattedDate = localDate && moment(localDate).format("MMM DD, YYYY");

    const [countdownTime, setCountdownTime] = useState({
        hours: "00",
        minutes: "00",
        seconds: "00",
    });

    const [isExpired, setIsExpired] = useState(false);

    const isTimeAboutToEnd =
        countdownTime.minutes !== "00" &&
        countdownTime.seconds !== "00" &&
        parseInt(countdownTime.hours) === 0 &&
        parseInt(countdownTime.minutes) < 3;
    const isColorRed = parseInt(countdownTime.hours) === 0 && parseInt(countdownTime.minutes) < 3;
    const unit = parseInt(countdownTime.hours) > 0 ? "hrs" : "min";

    useEffect(() => {
        isTimeAboutToEnd && timeAboutToEnd && timeAboutToEnd(true);
        if (formattedDate && localTime) {
            const interval = setInterval(() => {
                const now = new Date().getTime();
                const countDownDate = new Date(formattedDate + " " + localTime).getTime();
                const distance = countDownDate - now;

                if (distance < 0) {
                    setIsExpired(true);
                    orderExpired && orderExpired(true);
                    clearInterval(interval); // Stop the interval once expired
                } else {
                    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    setCountdownTime({
                        hours: String(hours).padStart(2, "0"),
                        minutes: String(minutes).padStart(2, "0"),
                        seconds: String(seconds).padStart(2, "0"),
                    });

                    setIsExpired(false);
                }
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [countdownTime, isTimeAboutToEnd, expiryDate, timeout]);

    return (
        <span className={`timeout-countdown ${className}`}>
            {!noText && isExpired ? (
                formatMessage(messages.orderExpired)
            ) : (
                <>
                    {!noText && `${formatMessage(messages.orderExpireTime)} `}
                    <span className={`${textClassName || "black-color"} ${isColorRed ? "alert-red-color" : ""}`}>{`${
                        parseInt(countdownTime.hours) > 0 ? `${countdownTime.hours}:` : ""
                    }${countdownTime.minutes}:${countdownTime.seconds}`}</span>
                    {showUnit ? ` ${unit}` : ""}
                </>
            )}
        </span>
    );
};
export default TimeOutCountDown;
